export default __webpack_public_path__ + "static/media/home.d59e6b74.gif";